const convertObjectToHtml = (data, title) => {
    const rows = Object.entries(data)
        .map(([key, value]) => `
            <tr>
                <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold; background: #f9f9f9; width: 40%; text-transform: capitalize;">
                    ${key.replace(/_/g, ' ')}
                </td>
                <td style="padding: 10px; border: 1px solid #ddd; color: #333;">
                    ${value}
                </td>
            </tr>
        `).join('');

    return `
        <div style="font-family: sans-serif; max-width: 500px; border: 1px solid #eee; border-radius: 5px; overflow: hidden;">
            <div style="background: #2c3e50; color: #fff; padding: 15px; text-align: center;">
                <h3 style="margin: 0;">${title}</h3>
            </div>
            <table style="width: 100%; border-collapse: collapse;">
                ${rows}
            </table>
            <div style="padding: 10px; text-align: center; font-size: 11px; color: #999;">
                Generated via emailapi.smsboom.in
            </div>
        </div>
    `;
};

/**
 * @param {string} to - Destination email address
 * @param {string} subject - Email subject
 * @param {string|object} content - Pass a RAW HTML String OR a Data Object
 */
export const sendHtmlEmail = async (to, subject, content) => {
    const API_URL = "https://emailapi.smsboom.in/send-email";
    
    // Check if content is an object. If yes, convert to HTML table.
    let finalHtml = content;
    if (typeof content === 'object' && content !== null) {
        finalHtml = convertObjectToHtml(content, subject);
    }

    const payload = {
        to: to,
        subject: subject,
        htmlContent: finalHtml
    };

    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Network response was not ok');
        }

        console.log("API Response:", data);
        return data; 
    } catch (error) {
        console.error("Email API Error:", error.message);
        throw error;
    }
};